export const clearAccentMarks = (phrase: string) => {
    const from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç";
    const to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuuNncc";
    const mapping = {} as any;
    // eslint-disable-next-line no-plusplus
    for (let i = 0, j = from.length; i < j; i++)
        mapping[from.charAt(i)] = to.charAt(i);
    const convertAccentMark = (str: string) => {
        const ret = [];
        // eslint-disable-next-line no-plusplus
        for (let i = 0, j = str.length; i < j; i++) {
            const c = str.charAt(i);
            // eslint-disable-next-line no-prototype-builtins
            if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
            else ret.push(c);
        }
        return ret.join("");
    };
    return convertAccentMark(phrase);
};
